<template>
  <tbody style="border-width: 1px">
    <tr>
      <td @click="toggleModuleInfo(null, null)" class="cursor-pointer">
        {{ afangi.namsgrein_afanganr }}
        <span v-if="afangi.stada_afanga === 5" style="color: red;">Ú
          <span v-if="afangi.dags_lokid" style="color: red;"> - {{
            formatDate(afangi.dags_lokid) }}
          </span>
        </span>

      </td>
      <td v-for="fjar in afangi.fjarvistir" :key="`${afangi.ferill_id}-${fjar.teg_fjarvista}`" class="cursor-pointer"
        @click="toggleModuleInfo(fjar, null)">
        {{ fjar.fj > 0 ? fjar.fj : '' }}
      </td>
      <td v-for="forf in afangi.forfoll" :key="`${afangi.ferill_id}-${forf.teg_forfalla}`" class="cursor-pointer"
        @click="toggleModuleInfo(null, forf)">
        {{ forf.fj > 0 ? forf.fj : '' }}
      </td>
      <td>{{ afangi.fjarvistarstig_ofl.length > 0 ? afangi.fjarvistarstig_ofl[0].fj_fjarv_forfoll_id : 0 }}</td>
      <td>{{ afangi.fjarvistarstig_ofl.length > 0 ? afangi.fjarvistarstig_ofl[0].fjarvistar_stig : '' }}</td>
      <td v-if="schoolSettings.maetingarhlutfall_stig === 1"
        :class="getAttendanceColor(afangi.maeting.length > 0 && afangi.maeting[0].maeting)">
        {{ afangi.maeting.length > 0 && afangi.maeting[0].maeting ? `${afangi.maeting[0].maeting}%` : '' }}
      </td>
      <td v-if="schoolSettings.maetingarhlutfall_raun === 1"
        :class="getAttendanceColor(afangi.maeting.length > 0 && afangi.maeting[0].maeting_raun)">
        {{ afangi.maeting.length > 0 && afangi.maeting[0].maeting_raun ? `${afangi.maeting[0].maeting_raun}%` : '' }}
      </td>
      <td v-if="schoolSettings.maetingarhlutfall_onn === 1"
        :class="getAttendanceColor(afangi.maeting.length > 0 && afangi.maeting[0].maeting_onn)">
        {{ afangi.maeting.length > 0 && afangi.maeting[0].maeting_onn ? `${afangi.maeting[0].maeting_onn}%` : '' }}
      </td>
      <td v-if="schoolSettings.maetingarhlutfall_einkunn === 1"
        :class="getAttendanceColor(afangi.maeting.length > 0 && afangi.maeting[0].maeting_einkunn)">
        {{ afangi.maeting.length > 0 && afangi.maeting[0].maeting_einkunn ? `${afangi.maeting[0].maeting_einkunn}%` : ''
        }}
      </td>
    </tr>
    <tr v-if="showDetails" style="background-color: #fff">
      <td colspan="100%" style="font-size: 12px">
        <div style="padding-left: 6px">
          <strong>Kóði: {{ selectedAbsence ? selectedAbsence.kodi : '' }}{{ selectedLeave ? selectedLeave.kodi : ''
          }}</strong>
          <div v-if="!loading && details.length === 0">Engar skráningar fundust</div>
        </div>
        <Loader v-if="loading"></Loader>
        <table class="table no-border less-padding" v-if="details.length > 0">
          <tr>
            <th>Vikudagur</th>
            <th>Dags.</th>
            <th>Frá</th>
            <th>Til</th>
            <th>Skráð</th>
            <th>Hópur</th>
            <th>Stig</th>
            <th>Viðvera</th>
            <th>Forföll</th>
            <th>Aths.</th>
            <th>Skráð af</th>
          </tr>
          <tr v-for="detail in details" :key="detail.fjarv_forfoll_id">
            <td>{{ detail.heiti_dags }}</td>
            <td>{{ detail.dags }}</td>
            <td>{{ detail.timi_fra }}</td>
            <td>{{ detail.timi_til }}</td>
            <td>{{ detail.dags_skrad }}</td>
            <td>{{ detail.hopur }}</td>
            <td>{{ detail.fjarvistar_stig }}</td>
            <td>{{ detail.kodi }}</td>
            <td>{{ detail.kodi1 }}</td>
            <td>{{ detail.athugasemd }}</td>
            <td>{{ detail.nafn }}</td>
          </tr>
        </table>
      </td>
    </tr>
  </tbody>
</template>

<script>
import attendance from '@/api/attendance';
import moment from 'moment';

import { mapActions, mapGetters } from 'vuex';
import Loader from '@/components/common/Loader.vue';

export default {
  name: 'attendance-module',
  props: ['afangi'],
  components: {
    Loader,
  },
  computed: {
    ...mapGetters(['loggedInUserHasReadPermission', 'loggedInUserHasWritePermission', 'schoolSettings']),
  },
  data() {
    return {
      showDetails: false,
      selectedAbsence: '',
      selectedLeave: '',
      details: [],
      loading: false,
    };
  },
  methods: {
    formatDate(date) {
      return moment(date).format('DD.MM.YYYY');
    },
    getAttendanceColor(item) {
      if (item < 80) {
        return 'attendancePercentageUnder80';
      }
      if (item >= 80 && item < 90) {
        return 'attendancePercentageUnder90';
      }
      return '';
    },
    async getAttendanceDetail() {
      try {
        this.showDetails = true;
        this.loading = true;
        const response = await attendance.getAttendanceDetails(
          this.afangi.ferill_id,
          this.selectedAbsence ? this.selectedAbsence.teg_fjarvista : '',
          this.selectedLeave ? this.selectedLeave.teg_forfalla : '',
        );
        this.details = response.data.items;
      } catch (e) {
        this.$log.error(e);
        this.displayError(`Óvænt villa (${e.response ? e.response.status : -1}) kom upp. Vinsamlegast reyndu aftur.`);
      } finally {
        this.loading = false;
      }
    },
    toggleModuleInfo(absence, leaveOfAbsence) {
      const oldId = (this.selectedAbsence && this.selectedAbsence.teg_fjarvista) || (this.selectedLeave && this.selectedLeave.teg_forfalla);
      const currentId = (absence && absence.teg_fjarvista) || (leaveOfAbsence && leaveOfAbsence.teg_forfalla);
      this.details = [];
      if ((!absence && !leaveOfAbsence && this.showDetails) || oldId === currentId) {
        this.selectedAbsence = {};
        this.selectedLeave = {};
        this.showDetails = false;
      } else {
        this.selectedAbsence = absence || {};
        this.selectedLeave = leaveOfAbsence || {};
        this.getAttendanceDetail();
      }
    },
    ...mapActions({
      displayError: 'displayError',
      displaySuccess: 'displaySuccess',
    }),
  },
};
</script>
<style></style>
